// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"7b7f8731","151":"49cadd59","215":"382a1e89","683":"7b7f8731"}[chunkId] + ".chunk.css";
};